// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/login_bg_alt1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logout {
  height: 100vh;
  background-color: rgb(193, 190, 255);
  display: flex;
  align-items: center;
  justify-content: center;
}
.logout .card {
  width: 50%;
  display: flex;
  background-color: white;
  border-radius: 10px;
  min-height: 600px;
  overflow: hidden;
}
.logout .card .left {
  flex: 1 1;
  background: linear-gradient(rgba(39, 11, 96, 0.5), rgba(39, 11, 96, 0.5)), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center;
  background-size: cover;
  padding: 50px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  color: white;
}
.logout .card .left h1 {
  font-size: 50px;
  line-height: 50px;
}
.logout .card .left span {
  font-size: 14px;
}
.logout .card .left button {
  width: 50%;
  padding: 10px;
  border: none;
  background-color: white;
  color: rebeccapurple;
  font-weight: bold;
  cursor: pointer;
}
.logout .card .right {
  flex: 1 1;
  padding: 50px;
  display: flex;
  flex-direction: column;
  gap: 50px;
  justify-content: center;
}
.logout .card .right h1 {
  color: #555;
}
.logout .card .right .error {
  color: red;
  font-size: 14px;
}
.logout .card .right form {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.logout .card .right form input {
  border: none;
  border-bottom: 1px solid lightgray;
  padding: 20px 10px;
}
.logout .card .right form button {
  width: 50%;
  padding: 10px;
  border: none;
  background-color: #938eef;
  color: white;
  font-weight: bold;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/logout/logout.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AACJ;AACI;EACE,SAAA;EACA,yHAAA;EAGA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AADN;AAGM;EACE,eAAA;EACA,iBAAA;AADR;AAQM;EACE,eAAA;AANR;AASM;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;AAPR;AAWI;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AATN;AAWM;EACA,WAAA;AATN;AAWM;EACE,UAAA;EACA,eAAA;AATR;AAYM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAVR;AAYQ;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;AAVR;AAaQ;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAXV","sourcesContent":[".logout {\n  height: 100vh;\n  background-color: rgb(193, 190, 255);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .card {\n    width: 50%;\n    display: flex;\n    background-color: white;\n    border-radius: 10px;\n    min-height: 600px;\n    overflow: hidden;\n\n    .left {\n      flex: 1;\n      background: linear-gradient(rgba(39, 11, 96, 0.5), rgba(39, 11, 96, 0.5)),\n        url(\"../../assets/login_bg_alt1.png\")\n          center;\n      background-size: cover;\n      padding: 50px;\n      display: flex;\n      flex-direction: column;\n      gap: 30px;\n      color: white;\n\n      h1 {\n        font-size: 50px;\n        line-height: 50px;\n      }\n      \n\n      p {\n      }\n\n      span {\n        font-size: 14px;\n      }\n      \n      button {\n        width: 50%;\n        padding: 10px;\n        border: none;\n        background-color: white;\n        color: rebeccapurple;\n        font-weight: bold;\n        cursor: pointer;\n      }\n    }\n\n    .right {\n      flex: 1;\n      padding: 50px;\n      display: flex;\n      flex-direction: column;\n      gap: 50px;\n      justify-content: center;\n\n      h1 {\n      color: #555;\n      }\n      .error {\n        color: red;\n        font-size: 14px;\n      }\n      \n      form {\n        display: flex;\n        flex-direction: column;\n        gap: 30px;\n        \n        input {\n        border: none;\n        border-bottom: 1px solid lightgray;\n        padding: 20px 10px;\n        }\n        \n        button {\n          width: 50%;\n          padding: 10px;\n          border: none;\n          background-color: #938eef;\n          color: white;\n          font-weight: bold;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
